const Marquee = ({ text }) => {
  const row = Array.from({ length: 6 }, () => text);
  return (
    <div className="overflow-hidden border-y border-teal-line bg-panel py-5" aria-hidden="true">
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((t, i) => (
              <span key={i} className="mx-8 font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tight text-white/90">
                {t}
                <span className="mx-8 text-mint">/</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
